import { render, staticRenderFns } from "./QurbanTracking.vue?vue&type=template&id=4026000c"
import script from "./QurbanTracking.vue?vue&type=script&lang=js"
export * from "./QurbanTracking.vue?vue&type=script&lang=js"
import style0 from "./QurbanTracking.vue?vue&type=style&index=0&id=4026000c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports